export default __webpack_public_path__ + "6c1a95cc1dc45fc7de8f4f6f8e21ec9b.png";